export enum CertificateDynamicInputType {
  Text = 1,
  Image = 2,
  Repeatable = 3,
  Object = 4,
  Number = 5,
  Static = 6,
  File = 7,
  Signature = 8,
}

export const CertificateDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Image,
  CertificateDynamicInputType.Repeatable,
  CertificateDynamicInputType.Object,
  CertificateDynamicInputType.Number,
  CertificateDynamicInputType.Static,
  CertificateDynamicInputType.Signature,
];

export const CertificateDynamicInputIcons = {
  [CertificateDynamicInputType.Text]: 'text',
  [CertificateDynamicInputType.Image]: 'image',
  [CertificateDynamicInputType.Repeatable]: 'dual-arrow',
  [CertificateDynamicInputType.Object]: 'box',
  [CertificateDynamicInputType.Number]: 'relationship-count',
  [CertificateDynamicInputType.Static]: 'locked',
  [CertificateDynamicInputType.Signature]: 'signature',
};

export const CertificateBuilderDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Image,
  CertificateDynamicInputType.Repeatable,
  CertificateDynamicInputType.Object,
  CertificateDynamicInputType.Signature,
]

export const EndPointDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Object,
  CertificateDynamicInputType.Number,
  CertificateDynamicInputType.Static,
]

export const ProcessFlowDynamicInputIcons = {
  [CertificateDynamicInputType.Text]: 'text',
  [CertificateDynamicInputType.Image]: 'file',
  [CertificateDynamicInputType.Object]: 'box',
  [CertificateDynamicInputType.Number]: 'numbers',
  [CertificateDynamicInputType.File]: 'file',
  [CertificateDynamicInputType.Signature]: 'signature',
}

export const SampleValueCertificateDynamicInputTypes = [
  CertificateDynamicInputType.Text,
  CertificateDynamicInputType.Repeatable,
]